import React from "react";
import UsHome from "../Whyus";
import Testimonial from "../Testimonials";

// Data for the component
const data = [
  {
    title: "Creative digital solutions for every stage of your business",
    description:
      "We don’t just build websites or design logos we build digital experiences that turn browsers into buyers and ideas into impact.",
    features: [
      { text: "✔️ Custom websites for your brand" },
      { text: "✔️ Intuitive mobile apps" },
      { text: "📈 High-converting UI/UX design" },
      { text: "🎨 Branding that tells your story" },
      { text: "🚀 Marketing campaigns for growth" },
      { text: "📊 Strategies for long-term success" },
    ],
    image: "../images/whyp2.png",
  },
  {
    title: "Built for results. Backed by strategy. Inspired by you.",
    description:
      "We're not just service providers we're strategic partners invested in your success. Our team delivers measurable results through creativity and intelligence.",
    features: [
      { text: "🔍 Clear processes from day one" },
      { text: "🧩 Real-time collaboration" },
      { text: "🏗️ Scalable future-ready solutions" },
      { text: "⚙️ Fast, high-quality delivery" },
      { text: "🤝 Dedicated support always" },
      { text: "📈 Focus on ROI & growth" },
    ],
    image: "../images/whyp1.png",
  },
];


const WhyUs = () => {
  return (
    <section>
      <div className="portfolio-section py-8 pb-0 md:py-16 px-4 justify-center w-full max-w-7xl m-auto">
        <div className="flex flex-col">
          <div className="prose text-gray-900 text-center prose-sm prose-headings:font-normal prose-headings:text-xl">        
          <span className="text-3xl md:text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
          Why Choose Us?</span>
          <p className="text-balance mt-4 text-[12px] md:text-[16px]">
             We blend creative strategy with cutting-edge technology to deliver custom websites, apps, branding, and marketing solutions that help your business stand out. 
             Our team focuses on real-world results boosting visibility, engagement, and conversions. With a commitment to quality, innovation, and client satisfaction, <br></br>we don’t just build digital products we build brands that grow.
            </p>
          </div>

          {/* Mapping over data */}
          {data.map((section, index) => (
            <div key={index} className="mt-6 border-t pt-4">
            <div
                key={index}
                className={`flex gap-2 md:grid-cols-2 md:gap-24 items-center ${index % 2 === 0 ? "flex-col md:flex-row" : "flex-col md:flex-row-reverse"}`}
                >

                {/* Left or Right Content depending on the index */}
                <div>
                  <span className="text-sm max-w-max font-bold mb-4 text-left font-semibold text-black border-b-2 border-[#E12126] uppercase">
                    {index === 0 ? "Because why not" : "What Makes Us Different"}
                  </span>
                
                  <p className="text-4xl mt-2 tracking-tighter font-semibold  text-balance">
                    {section.title}
                  </p>
                  <p className="text-sm mt-4 text-gray-900 text-balance">
                    {section.description}
                  </p>
                  <div className="mt-6 text-xs font-medium grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-2 text-gray-950">
                    {section.features.map((feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className="inline-flex items-center gap-2 text-xs text-gray-700"
                      >
                       
                        <span className="text-gray-950 text-[12px] md:text-[14px] font-medium text-sm">
                          {feature.text}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right or Left Image depending on the index */}
                <div className="h-full">
                  <img
                    src={section.image}
                    alt="Image"
                    className=" shadow-box shadow-gray-500/30 overflow-hidden aspect-square w-full h-full max-w-[600px] object-contain object-center"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <UsHome/>
      <Testimonial/>
    </section>
  );
};

export default WhyUs;
